import { combineReducers } from "redux";
import registrationReducer from "./registrationReducer";
import userReducer from "./userReducer";
import editingLinkupReducer from "./editingLinkupReducer";
import linkupReducer from "./linkupReducer";
import conversationReducer from "./conversationReducer";
import notificationReducer from "./notificationReducer";
import userSentRequestsReducer from "./userSentRequestsReducer";
import messageReducer from "./messageReducer";
import locationReducer from "./locationSlice";
import userSettingsReducer from "./userSettingsReducer";
import socialReducer from "./socialReducer";

import { LOGOUT } from "../actions/actionTypes";

const appReducer = combineReducers({
  registration: registrationReducer,
  userSettings: userSettingsReducer,
  loggedUser: userReducer,
  linkups: linkupReducer,
  editingLinkup: editingLinkupReducer,
  conversation: conversationReducer,
  messages: messageReducer,
  notifications: notificationReducer,
  userSentRequests: userSentRequestsReducer,
  location: locationReducer,
  social: socialReducer, // friends, pending requests, blocked users
});

const rootReducer = (state, action) => {
  if (action.type === LOGOUT) {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
